import { Col, Row } from 'antd'
import React from 'react'
import MobBookingShortcuts from './components/MobBookingShortcuts'
import MobHealthcareConvenience from './components/MobHealthcareConvenience'
import MobQuickButtons from './components/MobQuickButtons'
import MobTrending from './components/MobTrending'
import useMobileWrapper from './hooks/useMobileWrapper'
import './styling/MobileDashboard.css'

const MobHome = () => {
  const { handleQuickButtonClick } = useMobileWrapper()

  return (
    <div className='mobile-dashboard-wrapper' style={{ paddingBottom: 80 }}>
      <Row gutter={[16, 16]} justify='center'>
        <Col span={24}>
          <MobBookingShortcuts showSOS />
        </Col>

        {/* PromoCarousel disabled
        <Col span={24}>
          <PromoCarousel />
        </Col>
        */}

        <Col span={24} style={{ marginTop: 24 }}>
          <h2
            style={{
              textAlign: 'left',
              fontSize: 18,
              color: '#000000',
              fontWeight: 500,
              margin: '0 0 16px 0',
              padding: '0 0 0 4px'
            }}
          >
            Manage your health
          </h2>
          <MobQuickButtons onButtonClick={handleQuickButtonClick} />
        </Col>

        <Col span={24} style={{ marginBottom: 0 }}>
          <MobHealthcareConvenience />
        </Col>

        <Col span={24} style={{ marginTop: -8 }}>
          <MobTrending />
        </Col>
      </Row>
    </div>
  )
}

export default MobHome
